import { SalesActivityChartWidget, SalesChartWidget } from "@/components/dashboard/widgets";
import { CashFlowChart } from "@/components/dashboard/CashFlowChart";
import { SalesProjectionChart } from "@/components/dashboard/SalesProjectionChart";
import { SalesOverview } from "@/components/dashboard/SalesOverview";
import { CollectionsRisk } from "@/components/dashboard/CollectionsRisk";
import { AnalyticsSummaryCards } from "@/components/dashboard/AnalyticsSummaryCards";
import { ProposalsChart } from "@/components/dashboard/ProposalsChart";
import { WisdropReports } from "@/components/dashboard/WisdropReports";

import { DateRangeProvider } from "@/components/dashboard/DateRangeContext";
import { DateRangeFilter } from "@/components/dashboard/DateRangeFilter";
import { DashboardErrorBoundary } from "@/components/dashboard/DashboardErrorBoundary";
import { Button } from "@/components/ui/button";
import { Printer } from "lucide-react";

const Index = () => {
  const handlePrint = () => {
    window.print();
  };

  return (
    
      <DateRangeProvider>
        <div className="p-6 space-y-8 animate-fade-in">
          {/* Dashboard Header with Date Filter */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h1 className="text-3xl font-bold tracking-tight">Analytics Dashboard</h1>
            </div>
            <div className="flex items-center gap-4">
              <Button
                variant="outline"
                onClick={handlePrint}
                className="bg-muted text-muted-foreground hover:bg-muted/80"
              >
                <Printer className="h-4 w-4 mr-2" />
                Print 1-pager
              </Button>
              <DateRangeFilter />
            </div>
          </div>

          {/* Analytics Summary Cards */}
          <DashboardErrorBoundary fallbackTitle="Analytics Summary Error">
            <AnalyticsSummaryCards />
          </DashboardErrorBoundary>

          {/* Proposals Chart */}
          <DashboardErrorBoundary fallbackTitle="Proposals Chart Error">
            <ProposalsChart />
          </DashboardErrorBoundary>

          {/* Sales Projection */}
          <DashboardErrorBoundary fallbackTitle="Sales Projection Error">
            <SalesProjectionChart />
          </DashboardErrorBoundary>

          {/* Sales Overview */}
          <DashboardErrorBoundary fallbackTitle="Sales Overview Error">
            <SalesOverview />
          </DashboardErrorBoundary>

          {/* Wisdrop Reports */}
          <DashboardErrorBoundary fallbackTitle="Wisdrop Reports Error">
            <WisdropReports />
          </DashboardErrorBoundary>

          {/* Cash Flow and Collections Row */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <DashboardErrorBoundary fallbackTitle="Cash Flow Error">
              <CashFlowChart />
            </DashboardErrorBoundary>
            <DashboardErrorBoundary fallbackTitle="Collections Risk Error">
              <CollectionsRisk />
            </DashboardErrorBoundary>
          </div>

        </div>
      </DateRangeProvider>
    
  );
};

export default Index;
